var _dec, _class;
import { Injectable } from "../inject/index.js";
import { AbstractLogger } from "./index.js";
/**
 * A specific logger that forwards its messages to a collection of loggers
 */
export let LoggerCollection = (_dec = Injectable({
  lifetime: 'singleton'
}), _dec(_class = class LoggerCollection extends AbstractLogger {
  constructor(...args) {
    super(...args);
    this.loggers = [];
  }
  async addEntry(entry) {
    const promises = this.loggers.map(l => l.addEntry(entry));
    await Promise.all(promises);
  }
  attachLogger(...loggers) {
    this.loggers.push(...loggers);
  }
}) || _class);
//# sourceMappingURL=logger-collection.js.map